import { DropAlert } from '../DropAlert'
import { DropPaper } from '../DropPaper'
import InputField from '../../common/util/InputField'

export const NamePatternEditor = ({ namePattern, setNamePattern }) => {
    return (
        <DropPaper
            id={'NamePatternEditor'}
            error={namePattern === null || namePattern.length === 0}
        >
            <div className="text-2xl mb-5">Asset Names</div>
            <div>
                The names of your assets will also be auto generated, using the
                pattern you define here
            </div>
            <div className="my-5 max-w-60">
                <InputField
                    type="text"
                    label="Name Pattern"
                    variant="bordered"
                    value={namePattern}
                    onChange={(e) => setNamePattern(e.target.value)}
                    isRequired={true}
                    isInvalid={namePattern === null || namePattern.length === 0}
                />
            </div>
            <DropAlert
                condition={namePattern !== null && namePattern.length > 0}
                severity="info"
            >
                This pattern will result in asset names like{' '}
                <b>
                    {namePattern} #01, {namePattern} #02, {namePattern} #03,
                </b>{' '}
                etc.
            </DropAlert>
            <DropAlert
                severity="error"
                condition={namePattern === null || namePattern.length === 0}
            >
                Name Pattern cannot be empty
            </DropAlert>
        </DropPaper>
    )
}
